import {Component, EventEmitter, OnInit} from '@angular/core';
import {PlayersService} from '../../../services/players.service';
import {cloneDeep} from "lodash";
import {debounceTime} from "rxjs";
import {THREE} from "@angular/cdk/keycodes";
import {ThisReceiver} from "@angular/compiler";

@Component({
  selector: 'app-players-page',
  templateUrl: './players-page.component.html',
  styleUrls: ['./players-page.component.scss']
})
export class PlayersPageComponent implements OnInit {

  /*
   * Договорённость относительно индикации порядка сортировки.
   * Подсвеченная стрелка указывает направление, в котором происходит возрастание:
   * 1. Возрастание происходит снизу вверх, если подсвечена стрелка вверх
   * 2. Возрастание происходит сверху вниз, если подсвечена стрелка вниз
   *
   * За подсветку стрелки отвечают переменные descendingOrder (отвечает за подсветку конкретной стрелки),
   * clickedHeader (отвечает за заголовок, стрелки в котором должны быть подсвечены).
   */


  private playersList;
  private playersListToDisplay;
  private clickedHeader;

  private _chosenOrder: string = '';
  private _dictOfOrders = {
    ascending: 'asc',
    descending: 'desc',
    initial: '',
  };

  private _arrayOfOrderedOrders = [
    'ascending',
    'descending',
    'initial',
  ];

  private _generator = function* (arr: Array<any>) {
    let index = 0;
    while (true) {
      yield  arr[index % arr.length]
      if (index < arr.length - 1) {
        index++;
      } else {
        index = 0;
      }
    }
  }

  private _currentGenerator;



  private descendingOrder = false;
  private titlesOrders = {
    '-': 1,
    '3un': 2,
    '2un': 3,
    '1un': 4,
    '1': 5,
    '2': 6,
    '3': 7,
    'kms': 8,
    'ms': 9,
    'msmk': 10,
    'zms': 11,
  };
  private searchObservable: EventEmitter<string> = new EventEmitter();

  private _actualQuery: string = '';

  private currentPage: number = 1;
  private currentPageSize: number = 50;
  private addToPageSize: number = 50;
  private needToContinueResponse = false;
  private observer: IntersectionObserver;

  private sortCallBack = {
      fullNameHeader: this.sortPlayersByFullName.bind(this),
      birthYearHeader: this.sortPlayersByBirthYear.bind(this),
      titleHeader: this.sortPlayersByTitle.bind(this),
      cityCountryHeader: this.sortPlayersByCountry.bind(this),
      playedDuelsHeader: this.sortPlayersByPlayedGamesNumber.bind(this),
  };
  constructor(private playersService : PlayersService) { }

  apiGetPlayersToDisplay() {
    return this.playersService.getPlayersToDisplay(
      this.currentPage,
      this.currentPageSize,
      this.clickedHeader,
      this.chosenOrder,
    ).subscribe((playersListToDisplay) => {
        this.setPlayersToDisplay(playersListToDisplay['results']);
        this.needToContinueResponse = !! playersListToDisplay['next'];
      });
  }

  ngOnInit(): void {
    // this.playersService.getAllPlayers().subscribe((playersList) => {
    //   this.setPlayersList(playersList);
    // });
    this.apiGetPlayersToDisplay()

    // крайне хреновый костыль, который заменяет FormGroup и сервис
    // в будущем лучше так не делать в среде компонентов Angular
    const searchInput = document.getElementById('query');

    this.searchObservable.pipe(debounceTime(300)).subscribe((searchQuery) => {
      // @ts-ignore
      this.actualQuery = searchInput.value;

      if (searchQuery && searchQuery === this.actualQuery) {
        this.playersService.search(searchQuery).subscribe((playersList) => {

          // @ts-ignore
          this.actualQuery = searchInput.value;

          if (searchQuery && searchQuery === this.actualQuery) {
            this.setPlayersToDisplay(
              // @ts-ignore
              playersList.filter((player) => player?.full_name?.toLowerCase().startsWith(searchQuery.toLowerCase()))
            );
          }
        });
      }
    });
  }

  getPlayersList() {
    return this.playersList;
  }

  setPlayersList(list) {
    this.playersList = list;
  }

  getPlayersToDisplay() {
    return this.playersListToDisplay;
  }

  setPlayersToDisplay(list) {
    this.playersListToDisplay = list;
  }

  searchPlayer(value) {
    if(value) {
      this.observer.disconnect();
      this.actualQuery = value;
      this.searchObservable.emit(this.actualQuery);
      // this.setPlayersToDisplay(
      //   this.getPlayersList().filter(
      //     (player) => player?.full_name?.toLowerCase().startsWith(value.toLowerCase())
      //   )
      // );
    } else {
      this.apiGetPlayersToDisplay()
      this.observer.observe(
        document.getElementById('lookedDataInTable')
      );
    }
  }

  getTitlesOrders() {
    return this.titlesOrders;
  }






  commonStringsComparatorAscending(firstString, secondString) {
    let [firstLowered, secondLowered] = [firstString, secondString];

    if (typeof firstLowered === 'string') {
      [firstLowered, secondLowered] = [firstLowered.toLowerCase(), secondLowered.toLowerCase()];
    }

    this.setDescendingOrderFlag(false);
    if (firstLowered > secondLowered) {
      return 1;
    }

    if(firstLowered < secondLowered) {
      return  -1;
    }
    return 0;
  }

  commonStringsComparatorDescending(firstString, secondString) {
    let [firstLowered, secondLowered] = [firstString, secondString];

    if (typeof firstLowered === 'string') {
      [firstLowered, secondLowered] = [firstLowered.toLowerCase(), secondLowered.toLowerCase()];
    }

    this.setDescendingOrderFlag(true);
    if (firstLowered < secondLowered) {
      return 1;
    }

    if(firstLowered > secondLowered) {
      return  -1;
    }

    return 0;
  }

  sortPlayersByFullName(firstPlayer, secondPlayer) {
    const firstFullName = firstPlayer?.full_name || '-';
    const secondFullName = secondPlayer?.full_name || '-';

    return this.commonStringsComparatorAscending(firstFullName, secondFullName);
  }

  sortPlayersByBirthYear(firstPlayer, secondPlayer) {
    const firstBirthYear = firstPlayer.birthdate?.split('-')[0] || '-';
    const secondBirthYear = secondPlayer.birthdate?.split('-')[0] || '-';

    return  this.commonStringsComparatorAscending(firstBirthYear, secondBirthYear);
  }

  sortPlayersByTitle(firstPlayer, secondPlayer) {

    const firstTitleOrder = this.getTitlesOrders()[firstPlayer?.title];
    const secondTitleOrder = this.getTitlesOrders()[secondPlayer?.title];

    return this.commonStringsComparatorDescending(firstTitleOrder || -2, secondTitleOrder || -2);

  }

  sortPlayersByCountry(firstPlayer, secondPlayer) {
    const firstCountry = firstPlayer?.city?.region?.country?.name || 'я';
    const secondCountry = secondPlayer?.city?.region?.country?.name || 'я';

    return this.commonStringsComparatorAscending(firstCountry, secondCountry);
  }

  sortPlayersByPlayedGamesNumber(firstPlayer, secondPlayer) {
    const firstDuelsNumber = firstPlayer.count_duel_series;
    const secondDuelsNumber = secondPlayer.count_duel_series;

    return this.commonStringsComparatorDescending(firstDuelsNumber, secondDuelsNumber);
  }

  getSortCallBack(key) {
    return this.sortCallBack[key];
  }

  getClickedHeaderId() {
    return this.clickedHeader;
  }

  setClickedHeaderId(value) {
    if (this.getClickedHeaderId() !== value) {
      this.clickedHeader = value;
      this._currentGenerator = this._generator(this._arrayOfOrderedOrders);
    }

    this.chosenOrder = this._dictOfOrders[this._currentGenerator.next().value];

    this.apiGetPlayersToDisplay();
  }

  setDescendingOrderFlag(value: boolean) {
    this.descendingOrder = value;
  }

  isDescendingOrder() {
    return this.descendingOrder;
  }


  ngAfterViewInit() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 1],
    };

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && this.needToContinueResponse) {
        this.currentPageSize = this.currentPageSize + this.addToPageSize;

        this.apiGetPlayersToDisplay()
      }
    }, options);

    this.observer.observe(
      document.getElementById('lookedDataInTable')
    );
  }

  get actualQuery(): string {
    return  this._actualQuery;
  }

  set actualQuery(query) {
    this._actualQuery = query;
  }

  get chosenOrder(): string {
    return this._chosenOrder;
  }

  set chosenOrder(value: string){
    this._chosenOrder = value;
  }

  get dictOfOrders() {
    return {...this._dictOfOrders};
  }

  get arrayOfOrderedOrders() {
    return [...this._arrayOfOrderedOrders];
  }
}
